export default __webpack_public_path__ + "static/media/EP01_ERYTHREE.e556d817.mp3";